import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import React from "react";
import { useCurrencyFormatter } from "../hooks/useCurrencyFormatter";
import MortgageSimulator from "../simulator";

interface SavingsAccountsTableProps {
  sim: MortgageSimulator;
}

export default function SavingsAccountsTable({
  sim,
}: SavingsAccountsTableProps) {
  const c = useCurrencyFormatter();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Account Name</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Initial Balance</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Contribution</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Interest Rate</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Compounding</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Total Interest Earned</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sim.additionalCapitalRepayments && (
            <TableRow>
              <Tooltip title="This account holds the additional capital repayments made towards the mortgage.">
                <TableCell>ACR Reserve Account</TableCell>
              </Tooltip>
              <TableCell align="right">-</TableCell>
              <Tooltip
                title={`${c(sim.maxAffordable, true)} monthly, minus mortgage payment.`}
              >
                <TableCell align="right">Varies</TableCell>
              </Tooltip>
              <TableCell align="right">{sim.savingsInterestRate}%</TableCell>
              <TableCell align="right">Monthly</TableCell>
              <TableCell align="right">
                {c(sim.totalInterestEarnedInAccount(-1))}
              </TableCell>
            </TableRow>
          )}
          {sim.savingsAccounts.map((account, i) => (
            <TableRow key={i}>
              <TableCell>
                {account.name || `Unnamed Account ${i + 1}`}
              </TableCell>
              <TableCell align="right">
                {account.initialAmount > 0
                  ? c(account.initialAmount, true)
                  : "-"}
              </TableCell>
              <TableCell align="right">
                {c(account.contributionAmount || 0, true)}{" "}
                {account.contributionFrequency === "monthly"
                  ? "monthly"
                  : "yearly"}
              </TableCell>
              <TableCell align="right">{account.interestRate || 0}%</TableCell>
              <TableCell align="right">
                {account.interestCompounding === "monthly"
                  ? "Monthly"
                  : "Yearly"}
              </TableCell>
              <TableCell align="right">
                {c(sim.totalInterestEarnedInAccount(i))}
              </TableCell>
            </TableRow>
          ))}
          {(sim.additionalCapitalRepayments &&
            sim.savingsAccounts.length > 0) ||
          sim.savingsAccounts.length > 1 ? (
            <TableRow>
              <TableCell>
                <strong>Total</strong>
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell align="right">
                <strong>{c(sim.totalInterestEarned)}</strong>
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
